export const topResults = "U4d";
export const allResults = "V4d";
export const pinned = "W4d";
export default {topResults,allResults,pinned};